import {
  ResourceEmptyState,
  SectionWithHeader,
  TextButtonLink,
} from '@maia/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { getActivitiesOptions } from './queryOptions';
import { ActivityList } from '../../shared/activity/list';

export function ActivitiesList() {
  const { guid } = useParams({
    from: '/_authenticated/claims/$guid',
  });

  const { data } = useSuspenseQuery(getActivitiesOptions(guid, undefined, 3));

  return (
    <SectionWithHeader
      title="Laatste activiteiten"
      resource="laatste activiteiten"
      action={
        <TextButtonLink
          size="tiny"
          to={`/claims/$guid/activities`}
          params={{ guid }}
        >
          Bekijk alles
        </TextButtonLink>
      }
    >
      {data.response.length === 0 ? (
        <ResourceEmptyState message={'Er zijn geen laatste activiteiten'} />
      ) : (
        <ActivityList activities={data.response} />
      )}
    </SectionWithHeader>
  );
}
